module.exports = __webpack_public_path__ + "img/pause3.27e94ad0.png";